import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import KpsEditor from "../editor/KpsEditor";
import { withTranslation, Trans } from "react-i18next";
import { DatePicker } from "@material-ui/pickers";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import axios, { contentClient } from "../../AxiosClient";
import KpsDialog from "../kps-dialog/KpsDialog";
import { containsScriptOrSVG, containsBadCharacter } from "../../utils/ContentChecker";
import {
  setGlobalAlert
} from "../../redux/actions/universalActions";
const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: "none",
  },
  flex: {
    display: "flex",
    flexDirection: "column",
  },
  paper: {
    pointerEvents: "auto",
  },
});
export class CreateRework extends Component {
  static propTypes = {
    documentId: PropTypes.number.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      slateRef: null,
      text: "",
      reworkTargetDate: null,
      reworkUrgency: "Medium",
      attachmentIds: [],
      width: 450,
      height: 650,
      saving: false,
    };
    this.slateChange = this.slateChange.bind(this);
    this.submitRework = this.submitRework.bind(this);
  }
  render() {
    const { classes, t } = this.props;
    // const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    return (
      <KpsDialog
        loading={this.state.saving}
        resize={(width, height) => this.setState({ width, height })}
        id="createRework"
        open={this.props.open}
        title={<Trans i18nKey="document_sidebar_rework_request" />}
        accept={this.submitRework}
        close={this.props.changeOpenCreateRework}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ marginBottom: 20 }}>
            <DatePicker
              id="create-rework-target-date"
              autoOk
              label={t("document_sidebar_target_date")}
              disablePast
              value={this.state.reworkTargetDate}
              onChange={this.handleTargetDateChange}
              DialogProps={{ style: { zIndex: 1302 } }}
              style={{ width: "40%", marginRight: 30 }}
              minDate={new Date()}
            />
            <FormControl style={{ marginBottom: 5, width: "25%" }}>
              <InputLabel>Urgency</InputLabel>
              <Select
                value={this.state.reworkUrgency}
                onChange={this.handleUrgencyChange}
                MenuProps={{ style: { zIndex: 1302 } }}
              >
                <MenuItem value="Low">
                  <Trans i18nKey="rework_urgency_low" />
                </MenuItem>
                <MenuItem value="Medium">
                  <Trans i18nKey="rework_urgency_medium" />
                </MenuItem>
                <MenuItem value="High">
                  <Trans i18nKey="rework_urgency_high" />
                </MenuItem>
              </Select>
            </FormControl>
          </div>
          <Typography color="textSecondary" gutterBottom>
            Describe the rework request
          </Typography>
          <KpsEditor
            simpleToolbar
            updateUploadArray={this.updateUploadArray}
            placeholder="Describe the rework request"
            onChange={this.slateChange}
            ref="section"
            height={this.state.height - 300}
            width={this.state.width - 48}
            newUploadId={this.newUploadId}
          />
        </div>
      </KpsDialog>
    );
  }
  updateUploadArray = (array) => {
    this.setState({ attachmentIds: array });
  };
  newUploadId = (response) => {
    let attachments = this.state.attachmentIds.splice(0);
    attachments.push(Number(response));
    this.setState({ attachmentIds: attachments });
  };
  slateChange = (event) => {
    this.setState({ text: event });
  };

  handleTargetDateChange = (event) => {
    this.setState({ reworkTargetDate: event });
  };

  handleUrgencyChange = (e) => {
    this.setState({ reworkUrgency: e.target.value });
  };

  setSlateRef = (ref) => {
    this.setState({ slateRef: ref });
  };

  submitRework = () => {
    if (containsScriptOrSVG([this.state.text])) {
      this.props.setGlobalAlert({type:"error", message:"harmful_content", open:true})
      return;
    } else if (containsBadCharacter([this.state.text])){
      this.props.setGlobalAlert({type:"error", message:"unusable_character", open:true})
      return;
    }
    this.setState({ saving: true });
    let reworkRVO = {
      targetId: this.props.revisionId,
      content: this.state.text,
      attachmentIds: this.state.attachmentIds,
      urgency: this.state.reworkUrgency,
      targetCompletionDate: this.state.reworkTargetDate
        ? this.state.reworkTargetDate.valueOf().toString()
        : "",
    };
    contentClient
      .post("/rework/", {
        ...reworkRVO,
      })
      .then((res) => {
        this.setState({ saving: false });
        this.props.addRework(res.data);
        this.props.changeOpenCreateRework();
      })
      .catch(() => this.setState({ saving: false }));
  };
}

const mapStateToProps = (state) => ({
  user: state.user.currentUser,
});
const mapDispatchToProps = {
  setGlobalAlert,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(CreateRework)));
